// Survival mode constants

export const SURVIVAL = {
  // Difficulty ramp (AI level by kills)
  DIFFICULTY_TABLE: [3, 3, 4, 4, 5, 5, 6, 6, 7, 7] as readonly number[], // index = kill count, capped at 7
  DIFFICULTY_CAP: 7,

  // Enemy spawning
  SPAWN_DELAY_MS: 1500,    // 1.5s pause between kill and next enemy spawn
  SPAWN_POSITIONS: [0.15, 0.3, 0.5, 0.7, 0.85] as readonly number[], // stage-fraction X positions
  SPAWN_MIN_DISTANCE: 200, // px — minimum distance from player to pick a spawn

  // Player heal on kill
  HEAL_ON_KILL: 30,        // % damage healed on kill (30% of current damage)

  // Void retreat on kill
  VOID_REWARD: 90,         // px void retreats on enemy kill

  // High score localStorage key
  HIGH_SCORE_KEY: 'gb_survival_high',

  // Grade thresholds (total trick score)
  GRADE_S: 15000,
  GRADE_A: 10000,
  GRADE_B: 5000,
  GRADE_C: 2000,
  // Below C = D
} as const;
